export default "/images/Avian.svg?2b3c50e74612381e127dfce7ea7089b0";